import { AppAvatar, Col, Row, UiBox, UiHStack, UiText } from "~/components/elements";
import React from "react";
import { Box, Step, StepIcon, StepIndicator, Stepper, StepSeparator, StepStatus } from "@chakra-ui/react";
import { InCompletedStepIcon, StarIcon } from "~/components/icons/SvgIcons";
import serena from "~/assets/img/v2/packages/serena.png";
import { useAppSelector } from "~/hooks";

interface Props {
  // children: React.ReactNode;
}

const steps = [
  { title: "Select your package", description: "Choose the package that suits you" },
  { title: "Choose your styles", description: "Select your outfits and backgrounds" },
  { title: "Define key features", description: "Help the AI model understand your features better" },
  { title: "Upload your photos", description: "Upload your best photos" },
  { title: "Complete", description: "Review your photos and select your favorites" },
];

export function DashboardStepper() {
  const activeStep = useAppSelector(state => state.dashboard.dashboardActiveStep);
  return (
    <Col
      // hideBelow="md"
      maxW={{ base: undefined, lg: "18.75rem" }}
      maxH={{ base: undefined, lg: "41rem" }}
      w="full"
      bgColor="#FFFFFF80"
      rounded="3xl"
      justifyContent="space-between"
      py={5}
      px={5}
      alignSelf="stretch"
    >
      <Stepper
        index={activeStep}
        orientation="vertical"
        height={{ base: "auto", md: "24rem" }}
        gap="3px"
        size="sm"
        justifyContent="flex-start"
      >
        {steps.map((step, index) => {
          const showOnMobile = index === activeStep;

          return (
            <Step
              key={index}
              // @ts-ignore
              display={{ base: showOnMobile ? "flex" : "none", md: "flex" }}
              pb={{ base: showOnMobile ? "0rem" : 0, md: "1.25rem" }}
            >
              <StepIndicator
                sx={{
                  "&[data-status=complete]": { background: "#ABD439", borderColor: "transparent", color: "white" },
                  "&[data-status=active]": { borderColor: "#ABD439" },
                }}
                borderColor="neutral.gray300"
                borderWidth="1.5px !important"
              >
                <StepStatus
                  complete={<StepIcon />}
                  incomplete={<InCompletedStepIcon boxSize={8} />}
                  active={<InCompletedStepIcon boxSize={8} color="#ABD439" />}
                />
              </StepIndicator>

              <Box>
                <UiText vr="title2">{step.title}</UiText>
                <UiText
                  vr="body2"
                  color="neutral.gray400"
                  mt={1}
                  noOfLines={3}
                  wordBreak="break-word"
                  whiteSpace="normal"
                >
                  {step.description}
                </UiText>
              </Box>

              <StepSeparator
                /* @ts-ignore */
                borderWidth="1px"
                borderStyle="dashed"
                borderColor="neutral.gray200"
                width={0}
                bg="transparent !important"
              />
            </Step>
          );
        })}
      </Stepper>
      <UiBox rounded="3xl" mt={8} bg="darkblue" p={5} hideBelow="sm">
        <UiHStack gap={1}>
          <StarIcon />
          <StarIcon />
          <StarIcon />
          <StarIcon />
          <StarIcon />
        </UiHStack>
        <UiText vr="body2" color="neutral.gray00" mt={3}>
          &quot;Super impressed with the quality. Much more convenient and affordable than a studio!&quot;
        </UiText>
        <Row mt={3}>
          <AppAvatar src={serena} height="2.125rem" width="2.125rem" boxSizing="content-box" />
          <Col ml={2}>
            <UiText vr="title2" color="neutral.gray00" minW="6rem">
              Serena L
            </UiText>
            <UiText vr="body3" color="neutral.gray300" minW="6rem">
              Tech entrepreneur
            </UiText>
          </Col>
        </Row>
      </UiBox>
    </Col>
  );
}
